/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/5/17
 * Copyright All Rights Reserved
 */

import { createSelector } from 'reselect';

const getToken = createSelector(
  state => state.token.value,
  token => token
);

const getUser = createSelector(
  state => state.token.user,
  user => user
);

export { getToken, getUser };
